import { render, staticRenderFns } from "./WhatMakesFC.vue?vue&type=template&id=8c3615cc&scoped=true&"
import script from "./WhatMakesFC.vue?vue&type=script&lang=ts&"
export * from "./WhatMakesFC.vue?vue&type=script&lang=ts&"
import style0 from "./WhatMakesFC.vue?vue&type=style&index=0&id=8c3615cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3615cc",
  null
  
)

export default component.exports